import React from 'react'

export default function TableDemo() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">Table Demo</h1>
      <p>Página de demonstração de tabelas</p>
    </div>
  )
}
